module.exports = __webpack_public_path__ + "static/media/delete_button.702112dd.png";